import { useEffect } from 'react';

/** Tailwind blue-50。会員・ランディング等の `to-br` グラデの下端側に合わせる（iOS PWA の下の透け帯用） */
export const AUTH_LIGHT_SCREEN_BG = '#eff6ff';

/** PinLogin ラッパーと同一 */
export const PIN_SCREEN_BG = '#00a48d';

/**
 * iOS PWA で viewport 外に body が透ける帯が出る場合、画面背景と同色にする。
 * アンマウントで直前の inline の色に戻す。
 */
export function useBodyBackgroundOnMount(color: string) {
  useEffect(() => {
    const prev = document.body.style.backgroundColor;
    document.body.style.backgroundColor = color;
    return () => {
      document.body.style.backgroundColor = prev;
    };
  }, [color]);
}
